var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {UpdateUserAsync as InvokeAsync , UpdateUserSync as InvokeSync}

async function UpdateUserAsync(LoginToken,Email,Params)
{
    var UpdateUserPromise = new Promise((resolve, reject) => {
        UpdateUserSync(LoginToken,Email,Params,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await UpdateUserPromise;
}

function UpdateUserSync(LoginToken,Email,Params,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/UpdateUser',                
        data  : {
            AppID     :KEYS.AWS_APPID,
            Email     :Email ,
            Params    :Params,
            LoginToken:LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
